import { PmtMatSearchQuery } from "@saleor/graphql";

interface UsePMTResultsDataProps {
  row: PmtMatSearchQuery;
}

const usePMTResultsData = ({ row }: UsePMTResultsDataProps) => {
  const rowsData = row?.pmtMatSearch;

  const columnsList: TableColumn[] = [
    {
      id: "stockFg",
      label: "StockFG",
      style: { minWidth: 120, fontSize: 12 }
    },
    {
      id: "stockQa",
      label: "StockQA",
      style: { minWidth: 120 },
      align: "center"
    },
    {
      id: "stockWip",
      label: "StockWIP",
      style: { minWidth: 120 }
    },
    {
      id: "hold",
      label: "Hold",
      style: { minWidth: 120 }
    },
    {
      id: "custName",
      label: "CustName",
      style: { minWidth: 240 }
    },
    {
      id: "custId",
      label: "CusID",
      style: { minWidth: 120 }
    },
    {
      id: "custCode",
      label: "CustCode",
      style: { minWidth: 120 }
    },
    { id: "pc", label: "PC", style: { minWidth: 120 } },
    {
      id: "materialNo",
      label: "MaterialNo",
      style: { minWidth: 120 }
    },
    {
      id: "partNo",
      label: "PartNo",
      style: { minWidth: 120 }
    },
    {
      id: "description",
      label: "Description",
      style: { minWidth: 320 }
    },
    {
      id: "saleText",
      label: "SaleText",
      style: { minWidth: 320 }
    },
    {
      id: "rate",
      label: "Rate",
      style: { minWidth: 120 }
    },
    {
      id: "flute",
      label: "Flute",
      style: { minWidth: 120 }
    },
    {
      id: "board",
      label: "Board",
      style: { minWidth: 120 }
    },
    {
      id: "width",
      label: "Width",
      style: { minWidth: 120 }
    },
    {
      id: "length",
      label: "Length",
      style: { minWidth: 120 }
    },
    {
      id: "height",
      label: "Height",
      style: { minWidth: 120 }
    },
    {
      id: "vendorName",
      label: "Vendor Name",
      style: { minWidth: 240 }
    },
    {
      id: "netPrice",
      label: "Net Price",
      style: { minWidth: 120 }
    },
    {
      id: "purTxt",
      label: "PurTxt",
      style: { minWidth: 320 }
    },
    {
      id: "remark",
      label: "Remark",
      style: { minWidth: 320 }
    },
    {
      id: "weightBox",
      label: "Weight Box",
      style: { minWidth: 90 }
    },
    {
      id: "plant",
      label: "Plant",
      style: { minWidth: 90 }
    },
    {
      id: "saleOrg",
      label: "SaleOrg",
      style: { minWidth: 90 }
    },
    {
      id: "lastUpdate",
      label: "Last Update",
      style: { minWidth: 90 }
    }
  ];
  return {
    columnsList,
    rowsData
  };
};
export default usePMTResultsData;
